import * as React         from 'react';
import { useTranslation } from 'react-i18next';
import { Link }           from 'react-router-dom';

import './scss/style.scss';

import { useCommon }    from '../../providers/common';
import { useCompare }   from '../../providers/compare';

import CatalogCompareIcon from '../icons/CatalogCompareIcon';

const CompareCounter = function(props) {
  const { t } = useTranslation();

  const { isInterior } = props;

  const common  = useCommon();
  const compare = useCompare();

  const storageType = React.useMemo(() => {
    return isInterior ? 'interior' : 'entrance';
  }, [isInterior]);

  if (!compare.tradeOffers[storageType]?.length) {
    return null;
  }

  return (
    <Link
      className={'compare_counter_wrapper'}
      to={`${common.getUrlByTemplate('compare')}?type=${storageType}`}
    >
      <div className={'compare_icon_wrapper'}>
        <CatalogCompareIcon />
        <div className={'counter_wrapper'}>
          <p className={'counter'}>{compare.tradeOffers[storageType]?.length}</p>
        </div>
      </div>
      <p className={'compare_products_text'}>{t('btn_compare_products')}</p>
    </Link>
  );
};

export default CompareCounter;